import { SimpleDocCommand } from '../../DocsApp/commands/v5/types';
import { StandardToolResult } from '../../../types/standardToolResults';
import { CommandExecutionContext } from '../../../types/commands';
import { schemaToParameters } from '../../../utils/schemaToParameters';

export const contacts_import_csv: SimpleDocCommand = {
  id: 'contacts_import_csv',
  logicalName: 'contacts_import_csv',
  version: 'v1',

  description: `Import contacts from a CSV file into the address book. Supports LinkedIn connections exports and generic name/email CSVs.

**WHEN TO USE:** The user has uploaded or dragged in a CSV file of contacts (e.g. a LinkedIn connections export) and wants to import it.

**HOW TO USE:**
1. The user drags a CSV file entity into chat — you'll see it as context with an entityId/llmId
2. Call this tool with that fileEntityId

**Supported CSV formats (auto-detected by header):**
- LinkedIn: First Name, Last Name, Email Address, Company, Position, Connected On
- Generic: name/full_name, email, company, title/position

**EXAMPLE:**
{ "fileEntityId": "file_abc123", "source": "linkedin" }

**RETURNS:** { created: N, updated: N, skipped: N, contacts: [{ name, action }] }`,

  schema: {
    parameters: schemaToParameters({
      type: 'object',
      properties: {
        fileEntityId: {
          type: 'string',
          description: 'llmId or _id of the uploaded CSV file entity. Required unless csvContent is provided.',
        },
        csvContent: {
          type: 'string',
          description: 'Raw CSV text. Alternative to fileEntityId — provide one or the other.',
        },
        source: {
          type: 'string',
          description: "Provenance tag added to all imported contacts e.g. 'linkedin', 'hubspot', 'csv'",
          default: 'csv',
        },
        defaultTier: {
          type: 'string',
          description: 'Tier assigned to newly created contacts (default: regular)',
          enum: ['close', 'regular', 'archived'],
          default: 'regular',
        },
      },
      required: ['fileEntityId'],
    }),
  },

  handler: async (params: any, context: CommandExecutionContext): Promise<StandardToolResult> => {
    const { callToolRuntime } = await import('../../../utils/callToolRuntime');
    return callToolRuntime('contacts_import_csv', params, context);
  },
};
